import { Skeleton } from '@/components/custom';

const DataTableMobileSkeleton = ({ count = 5 }: { count?: number }) => {
	const keys = Array.from({ length: count }, () => crypto.randomUUID());

	return (
		<div className="space-y-4">
			{keys.map(key => (
				<div key={key} className="p-4 border rounded-lg bg-card shadow-xs space-y-3">
					<div className="flex items-center justify-between gap-3">
						<Skeleton className="h-5 w-28 rounded-md" />
						<Skeleton className="h-5 w-20 rounded-full" />
					</div>
					<Skeleton className="h-4 w-40" />
					<Skeleton className="h-4 w-32" />
					<Skeleton className="h-8 w-full rounded" />
				</div>
			))}
		</div>
	);
};

export default DataTableMobileSkeleton;
